import Big from 'big.js';
import * as graphql from 'generated/graphql';
import _ from 'lodash';
import { ITypeSpecificPolicy } from './shared';



export const Calculation: ITypeSpecificPolicy<graphql.Calculation> = {
  fields: {
    outputValue: {
      read: (existing, { }) => {
        return Big(existing);
      }
    },

    formattedValue: {
      read: (existing, { readField }) => {
        const valueFieldValue = readField<Big>('outputValue');
        const unitFieldValue = readField<graphql.DataPointUnit>('unit');
        if (_.isNil(valueFieldValue) || _.isNil(unitFieldValue)) {
          return existing;
        }

        const value = __divideNumber(valueFieldValue);
        const suffix = __getMagnitude(valueFieldValue);

        switch (unitFieldValue) {
          case 'percentage':
            return valueFieldValue.toNumber()
              .toLocaleString('en-US', {
                style: 'percent',
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });

          case 'usd':
            return value.toNumber()
              .toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) + suffix;

          case 'usdpershare':
            return value.toNumber()
              .toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) + suffix;

          case 'shares':
            return valueFieldValue.toNumber()
              .toLocaleString('en-US', {
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) + `${valueFieldValue.eq(1) ? ' share' : ' shares'}`;

          case 'days':
            return valueFieldValue.toNumber()
              .toLocaleString('en-US', {
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) + `${valueFieldValue.eq(1) ? ' day' : ' days'}`;

          case 'float':
            return valueFieldValue.toNumber()
              .toLocaleString('en-US', {
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });

          case 'multiple':
            return valueFieldValue.toNumber()
              .toLocaleString('en-US', {
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });

          default:
            return valueFieldValue.toNumber()
              .toLocaleString('en-US', {
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) + ' ' + unitFieldValue;
        }
      }
    }
  }
};



function __divideNumber(value: Big) {
  const abs = value.abs();
  if (abs.gte(1_000_000_000_000)) {
    return value.div(1_000_000_000_000);
  } else if (abs.gte(1_000_000_000)) {
    return value.div(1_000_000_000);
  } else if (abs.gte(1_000_000)) {
    return value.div(1_000_000);
  }

  return value;
}



function __getMagnitude(value: Big) {
  const abs = value.abs();
  if (abs.gte(1_000_000_000_000)) {
    return 'T';
  } else if (abs.gte(1_000_000_000)) {
    return 'B';
  } else if (abs.gte(1_000_000)) {
    return 'M';
  }

  return '';
}
